import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './styles.scss'
import { getParamId } from '@utilities/mdHandler'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import { history } from '@services/History'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import Input from '../../../adminv2/common/Input'
import Marketing from '@services/Marketing'
import uuid from 'uuid/v4'
import UploadImage from '@modules/formFields/UploadImage'
import { useDispatch } from 'react-redux'
import { showAlert } from '../alert/Alert.dux'
import Alert from '../../../adminv2/common/Alert'

const ContentUpdate = (props) => {
  const id = getParamId(props)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const titleHeader = id ? t('feedEditContent') : t('feedCreateContent')
  const editMode = id ? true : false
  const submitting = false

  const initialFormValues = {
    id: id ?? uuid(),
    section: '',
    order: 1,
    feed: '',
    feed_name: '',
    title: '',
    subtitle: '',
    image: '',
    icon: '',
    button_text: '',
    link: '',
    description: '',
    internal_link: '',
    topic: '',
    color: '',
    label: '',
  }
  const [formData, setFormData] = useState(initialFormValues)
  const [feeds, setFeeds] = useState([])

  const sectionOptions = [
    {
      label: 'usecase',
      value: 'usecase',
    },
    {
      label: 'featured',
      value: 'featured',
    },
    {
      label: 'quicklink',
      value: 'quicklink',
    },
  ]

  useEffect(() => {
    const updateEditValues = (values) => {
      const oldValues = {
        id: id,
        section: { label: values.section, value: values.section },
        order: values.order ?? 1,
        feed: { label: values.feed_name, value: values.feed_name, idFeed: values.feed },
        feed_name: values.feed_name,
        title: values.title,
        subtitle: values.subtitle,
        image: values.image,
        icon: values.icon,
        button_text: values.button_text,
        link: values.link,
        description: values.description,
        internal_link: values.internal_link,
        topic: values.topic,
        color: values.color,
        label: values.label,
      }

      setFormData(oldValues)
    }

    Marketing.MFeed.index().then((res) => {
      let tempFeed = []
      res.data.forEach((element) => {
        tempFeed.push({ idFeed: element.attributes.id, label: element.attributes.name })
      })
      setFeeds(tempFeed)
    })

    //en vez de hacerlo con el index hacerlo con el que le pasas un id y te lo devuelve

    /* id && Marketing.MContent.index().then(res => {
      console.log(id, " id a buscar")
      console.log(res.data, " los iddss")
      let actualContent = res.data.find(element => element.id === id)

      console.log(actualContent, " actualContent 🖤🖤🖤")
      actualContent && updateEditValues(actualContent.attributes)
    }) */

    id &&
      Marketing.MContent.show(id).then((res) => {
        updateEditValues(res.data.attributes)
      })
  }, [])

  const failureAlertOpening = (text) => {
    dispatch(
      showAlert({
        text: text ?? t('generalUpdatingErrorMEssage'),
        important: !text ? 'Oh snap!' : '',
        type: 'danger',
      })
    )
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    let formatData = structuredClone(formData)

    formatData.section = formData.section.label
    formatData.feed = formData.feed.idFeed

    if (formatData.order === '0') {
      formatData.order = '1'
    }

    editMode ? Marketing.MContent.update(id, formatData) : Marketing.MContent.store(formatData)

    history.push('/content')
  }

  return (
    <div className="content-update">
      <DashboardHeader title={titleHeader} total={null}>
        <Link className="btn btn-primary" to={`/content`}>
          {t('back')}
        </Link>
      </DashboardHeader>

      <Alert timeOut={3000} />

      <form className="integration-form" onSubmit={handleSubmit} id="company-form">
        <div className="container-fluid main-content">
          <div className="form-crud-feeds well">
            <section className="conf-content">
              <header className="header-content">
                <div className="header-content-titleContent">
                  {' '}
                  <h2>{t('feedConfigContent')}</h2>{' '}
                </div>
              </header>

              <div className="divided-content">
                <div className="divided-subcontent">
                  <label>{t('feedSectionAsigned')}*</label>

                  <Select
                    options={sectionOptions}
                    name="sectionAsigned"
                    required
                    value={formData.section}
                    onChange={(option) => {
                      setFormData({ ...formData, section: option })
                    }}
                  />
                </div>

                <div className="divided-subcontent">
                  <Input
                    className="form-control"
                    required
                    id="order"
                    name="order"
                    label={`${t('feedOrder')}*`}
                    placeholder={`${t('feedOrder')}`}
                    value={formData.order}
                    onChange={(value) => setFormData({ ...formData, order: value })}
                    displayRequiredMark={false}
                    type="number"
                  />
                </div>
              </div>

              <div className="complete-content">
                <label>{t('feedAsigned')}*</label>

                <Select
                  options={feeds}
                  required
                  value={formData.feed}
                  name="feedsAsigned"
                  onChange={(option) => {
                    setFormData({
                      ...formData,
                      feed: option,
                      feed_name: option.label,
                    })
                  }}
                />
              </div>
            </section>

            <hr />

            <section className="detail-content">
              <div>
                {' '}
                <h2>{t('feedDetailContent')}</h2>{' '}
              </div>

              <div className="complete-content">
                <Input
                  className="form-control"
                  id="title"
                  name="title"
                  label={`${t('feedTitle')}*`}
                  placeholder={`${t('feedTitle')}`}
                  value={formData.title}
                  required
                  onChange={(value) => setFormData({ ...formData, title: value })}
                  displayRequiredMark={false}
                  type="text"
                />

                <Input
                  className="form-control"
                  id="subtitle"
                  name="subtitle"
                  label={`${t('feedSubtitle')}`}
                  value={formData.subtitle}
                  onChange={(value) => setFormData({ ...formData, subtitle: value })}
                  displayRequiredMark={false}
                  type="text"
                />

                <Input
                  className="form-control-textarea"
                  id="description"
                  name="description"
                  label={t('feedDescriptionDetail')}
                  placeholder={t('Descripción')}
                  value={formData.description}
                  onChange={(value) => setFormData({ ...formData, description: value.target.value })}
                  displayRequiredMark={false}
                  type="textarea"
                />
              </div>

              <div className="divided-content">
                <div className="divided-subcontent">
                  <label>{t('feedImage')}</label>
                  <UploadImage
                    onChange={(value) => setFormData((prev) => ({ ...prev, image: value }))}
                    urlImageBD={formData.image}
                    alertMD={failureAlertOpening}
                  />
                  <p>{'[ 1Mb Max ]'}</p>

                  <Input
                    className="form-control"
                    id="button_text"
                    name="button_text"
                    label={t('feedButton')}
                    placeholder={t('feedButtonPlaceholder')}
                    value={formData.button_text}
                    onChange={(value) => setFormData({ ...formData, button_text: value })}
                    displayRequiredMark={false}
                    type="text"
                  />
                </div>

                <div className="divided-subcontent">
                  <label>{t('feedIcon')}</label>
                  <UploadImage
                    onChange={(value) => setFormData((prev) => ({ ...prev, icon: value }))}
                    urlImageBD={formData.icon}
                    alertMD={failureAlertOpening}
                  />
                  <p>{'[ 1Mb Max ]'}</p>

                  <Input
                    className="form-control"
                    id="link"
                    name="link"
                    label={`${t('feedLink')}*`}
                    placeholder={`${t('feedLink')}`}
                    value={formData.link}
                    required
                    onChange={(value) => setFormData({ ...formData, link: value })}
                    displayRequiredMark={false}
                    type="text"
                  />
                </div>
              </div>

              <div className="complete-content">
                <Input
                  className="form-control"
                  id="internal_link"
                  name="internal_link"
                  label={t('feedLinkDetail')}
                  value={formData.internal_link}
                  onChange={(value) => setFormData({ ...formData, internal_link: value })}
                  displayRequiredMark={false}
                  type="text"
                />
              </div>

              <div className="divided-content">
                <div className="divided-subcontent">
                  <Input
                    className="form-control"
                    id="Tematica"
                    name="Tematica"
                    label={t('feedTopic')}
                    sublabel={t('feedTopicSublabel')}
                    value={formData.topic}
                    onChange={(value) => setFormData({ ...formData, topic: value })}
                    type="text"
                  />
                </div>

                <div className="divided-subcontent">
                  <label>{t('feedColor')}</label>
                  <input
                    className="form-control"
                    id="color"
                    name="color"
                    value={formData.color}
                    onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                    type="color"
                  />
                </div>
              </div>

              <div className="divided-content">
                <div className="divided-subcontent">
                  <Input
                    className="form-control"
                    id="label"
                    name="label"
                    label={t('feedLabel')}
                    placeholder={t('feedLabelPlaceholder')}
                    value={formData.label}
                    onChange={(value) => setFormData({ ...formData, label: value })}
                    displayRequiredMark={false}
                    type="text"
                  />
                </div>
              </div>
            </section>
          </div>

          <div className="form-crud-feeds">
            <div className="button-content">
              <button type="submit" className="btn btn-primary save-button" disabled={submitting}>
                {t('save')}
              </button>
              <button
                type="button"
                className="btn btn-outline-primary cancel-button"
                disabled={submitting}
                onClick={() => history.push('/content')}
              >
                {t('cancel')}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}
export default ContentUpdate
